




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import tippy from 'tippy.js';

@Component
export default class SearchBox extends Vue {

  pendingDebounce:number = 0;
  hasFocus = false;

  public $refs!: {
    'search-input': HTMLInputElement
  };

  @Prop({ default: '',  type: String}) searchTerm!: string;
  @Prop({ default: '',  type: String}) toolTip!: string;
  @Prop({ default: '',  type: String}) pattern!: string;

  curSearchTerm:string = '';
  

  mounted() {
    tippy('[data-tippy-content]', {});
  }

  onInput(newSearchTerm:string, timeoutTime:number=300) {

    clearTimeout(this.pendingDebounce);
    this.pendingDebounce = window.setTimeout(() => this.emitUpdate(newSearchTerm), timeoutTime);
  }

  emitUpdate(newSearchTerm:string) {
    this.$emit('search', newSearchTerm.trim());
  }

  onFocus(){
    this.hasFocus = true;
  }

  onLoseFocus(){
    this.hasFocus = false
    document.body.focus()
  }

  setFocus() {
    this.$refs['search-input'].focus();
  }

}

